import { render, staticRenderFns } from "./materialChange.vue?vue&type=template&id=3ecad93e&scoped=true"
import script from "./materialChange.vue?vue&type=script&lang=js"
export * from "./materialChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecad93e",
  null
  
)

export default component.exports